<template lang="pug">
.wrapper.wrapper--sidebar
    aside.wrapper--sidebar__sidebar
        Sidebar(:isKey="isKey" :key="key")
    section.wrapper--sidebar__content
        router-view(:isKey="isKey" :resultGlobalBreadcrumb="breadcrumb")                    
</template>

<script>
import { mapState } from 'vuex';
import Sidebar from '@/components/shell/sidebar/Sidebar.vue';
import { decrypt } from '@/util/crypto';

export default {
    name: 'PageTargetDetail',
    components: {
        Sidebar,
    },
    data: function() {
        return {
            breadcrumb: {
                name: 'Target',
                url: '/target',
            },
        };
    },
    computed: {
        ...mapState([
            'load_data_status_single_target_detail',
            // 'load_data_status_overall_data_location',
            // 'test_ip',
            // 'profile_subheader',
            // 'overall_app_usage',
            // 'overall_data_location',
            // 'overall_recent_location',
            'load_data_status_overall_data_location',
            'load_data_status_overall_app_usage',
            'load_data_status_location',
            // 'load_data_status_location_count',
            'load_data_status_browsing',
            // 'load_data_status_browsing_count',
            'load_data_status_device_history',
            'load_data_status_tethered_device',
            'load_data_status_possible_location',
            'load_data_status_aerial_log',
            'load_data_status_signal_status',
            'load_data_status_profile',
            // 'load_data_status_profile_count',
            'load_data_status_get_contact',
            // 'load_data_status_vehicles',
            'load_data_status_travel_history',
            'load_data_status_tokped',
            'load_data_status_bank_account',
            'load_data_status_travel',
            'load_data_status_pln',
        ]),
        route() {
            return this.$route;
        },
        route_name() {
            return this.$route.matched[0] ? this.$route.matched[0].name : null;
        },
        key() {
            return this.$route.params.key;
        },
        isKey() {
            // return this.key!==undefined ? true : false;
            return this.key ? true : false;
        },
        id() {
            return this.$route.params.id;
        },
    },
    watch: {
        route(newData, oldData) {
            // if (newData.matched[0] && newData.matched[0].name === 'PageTargetDetail' && newData.name === 'target-detail-recent-location' && this.load_data_status_overall_data_location === false)
            //     this.getData();
            if (newData.matched[0].name === 'PageTargetDetail' && oldData.matched[0].name === 'PageTargetDetail') {
                // console.log(newData.matched[1].name)
                if (
                    (newData.matched[1].name === 'target-detail-recent-location' && this.load_data_status_overall_data_location.status === false) ||
                    (newData.matched[1].name === 'target-detail-application-usage' && this.load_data_status_overall_app_usage.status === false) ||
                    (newData.matched[1].name === 'target-detail-history-location' && this.load_data_status_location.status === false) ||
                    (newData.matched[1].name === 'target-detail-history-browsing' && this.load_data_status_browsing.status === false) ||
                    (newData.matched[1].name === 'target-detail-device-history' && this.load_data_status_device_history.status === false) ||
                    (newData.matched[1].name === 'target-detail-tethered-devices' && this.load_data_status_tethered_device.status === false) ||
                    (newData.matched[1].name === 'target-detail-possible-location' && this.load_data_status_possible_location.status === false) ||
                    (newData.matched[1].name === 'target-detail-aerial-log' && this.load_data_status_aerial_log.status === false) ||
                    (newData.matched[1].name === 'target-detail-signal-status' && this.load_data_status_signal_status.status === false) ||
                    (newData.matched[1].name === 'target-detail-profile' && this.load_data_status_profile.status === false) ||
                    (newData.matched[1].name === 'target-detail-prediction-nickname' && this.load_data_status_get_contact.status === false) ||
                    // (newData.matched[1].name === 'target-detail-vehicles' && this.load_data_status_vehicles === false)
                    // (newData.matched[1].name === 'target-detail-ticket' && this. === false)
                    (newData.matched[1].name === 'target-detail-marketplace' && this.load_data_status_tokped.status === false) ||
                    (newData.matched[1].name === 'target-detail-travel-history' && this.load_data_status_travel_history.status === false) ||
                    (newData.matched[1].name === 'target-detail-travel' && this.load_data_status_travel.status === false) ||
                    (newData.matched[1].name === 'target-detail-pln' && this.load_data_status_pln.status === false) ||
                    (newData.matched[1].name === 'target-detail-bank-account' && this.load_data_status_bank_account.status === false)
                )
                    // this.getData(true);
                    this.getData();
            }

            if (newData.matched[0] && newData.matched[0].name === 'PageTargetDetail' && newData.name === 'PageTargetDetailHome' && this.load_data_status_single_target_detail === false)
                this.getDataTarget();
        },
        route_name() {},
        /* eslint-disable no-unused-vars */
        // key(newKey, oldKey) {
        async key() {
            // add after trigger api on click menu
            if(this.load_data_status_overall_data_location !== false){
                await this.$store.dispatch('setEmptyResultData', []);
                this.getData();
            }
        },
        isKey() {},
        id(){
            this.getDataTarget()
        }
    },
    methods: {
        getData() {
            if (this.route_name === 'PageTargetDetail') {
                if (this.isKey) {

                    // console.log(this.route.matched[1].name)

                    let decrypt_data = decrypt(this.key);
                    decrypt_data = decrypt_data.split('&&');

                    var key = decrypt_data[0];
                    var type = decrypt_data[1];

                    // console.log([key, type])
                    let route = this.route.matched[1].name;

                    // [key, type, getApi='all', fromSidebar=false, detail_target=false]
                    this.$store.dispatch('getResultData', [key, type, route, false, true])
                    .then((resp) => {
                        // console.log(resp)
                        if (resp === 'not_allowed') {
                            this.$swal.fire({
                                icon: 'error',
                                // title: 'You have reached limit for search MSISDN '+ key +'!',
                                title: 'The limit has reached for search MSISDN '+ key +'!',
                                // text: 'You only can search this number 10 times a day',
                                // confirmButtonText: 'Yes!',
                                confirmButtonText: 'Ok',
                                // confirmButtonColor: '#DD6B55',
                                showCancelButton: false,
                                allowOutsideClick: false,
                            })
                            .then(() => {
                                // this.$router.push({ name: 'PageDashboard' });
                                this.$router.push({ name: 'PageTargetDetailHome', params: { id: this.id ,key: this.key }  })
                            });
                        }
                    });

                } else {
                    this.$store.dispatch('setEmptyResultData', []);
                }                
            }
        },
        getDataTarget() {
            if (this.route_name === 'PageTargetDetail') {
                if (this.isKey) {

                    this.$store.commit('setTargetRedirect', 'detail');        
                    this.$store.dispatch('getSingleTargetDetail', [this.id])
                    .then((resp) => {
                        if (resp === 'success') {
                            // this.showLoading(false);

                        } else {
                            this.error();
                        }
                    });
                }
            }
        },

        clickPopupShow: function() {
            // console.log('heho')
        },
    },
    async mounted() {
        // console.log('this.$route.name')
        // console.log(this.$route.name)
        // if (this.$route.name === 'PageTargetDetailHome')
        if (this.route_name === 'PageTargetDetail')
            this.getDataTarget();
        // if (this.$route.name === 'target-detail-recent-location')
        //     this.getData();
        if (
            this.route.matched[1].name === 'target-detail-recent-location' ||
            this.route.matched[1].name === 'target-detail-application-usage' ||
            this.route.matched[1].name === 'target-detail-history-location' ||
            this.route.matched[1].name === 'target-detail-history-browsing' ||
            this.route.matched[1].name === 'target-detail-device-history' ||
            this.route.matched[1].name === 'target-detail-tethered-devices' ||
            this.route.matched[1].name === 'target-detail-possible-location' ||
            this.route.matched[1].name === 'target-detail-aerial-log' ||
            this.route.matched[1].name === 'target-detail-signal-status' ||
            this.route.matched[1].name === 'target-detail-profile' ||
            this.route.matched[1].name === 'target-detail-prediction-nickname' ||
            // this.route.matched[1].name === 'target-detail-vehicles' ||
            // this.route.matched[1].name === 'target-detail-ticket' ||
            this.route.matched[1].name === 'target-detail-marketplace' ||
            this.route.matched[1].name === 'target-detail-travel-history' ||
            this.route.matched[1].name === 'target-detail-bank-account'
            
        ) {
            // add after trigger api on click menu
            await this.$store.dispatch('setEmptyResultData', []);
            this.getData();
        }
    },
}
</script>
